import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";

const pathMatches = (pathname, path) =>
  pathname === path || pathname.startsWith(`${path}/`);

const SidebarNavItem = ({
  to,
  icon,
  label,
  exact = false,
  activeLinks,
  visible = true,
  onNavigate = () => {},
}) => {
  const { pathname } = useLocation();

  if (!visible) return null;

  const paths = activeLinks || [to];
  const isActive = exact
    ? paths.some((path) => pathname === path)
    : paths.some((path) => pathMatches(pathname, path));

  return (
    <li className={classNames("nav-item", { active: isActive })}>
      <NavLink
        to={to}
        exact={exact}
        className="nav-link"
        activeClassName="active"
        isActive={() => isActive}
        aria-current={isActive ? "page" : undefined}
        onClick={onNavigate}
      >
        {icon && <FontAwesomeIcon className="fa-fw mr-2" icon={icon} />}
        <span>{label}</span>
      </NavLink>
    </li>
  );
};

export default SidebarNavItem;
